import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format, isToday } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCheckTime(timestamp: string | null | undefined): string {
  if (!timestamp) return 'N/A';
  
  const date = new Date(timestamp);
  
  // If it's today, show only time
  if (isToday(date)) {
    return format(date, 'h:mm a');
  }
  
  // If it's a previous day, show date and time
  return format(date, 'MMM d, h:mm a');
}
